import {Injectable} from '@angular/core';
import {SelectItem, SelectItemGroup} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldTable} from '@tj/tj-dmp-lib-api';
import TypeEnum = FieldTable.TypeEnum;
import CategoryFieldEnum = FieldTable.CategoryFieldEnum;

@Injectable({
    providedIn: 'root',
})
export class DatabaseUtilService {

    constructor(private readonly transate: TranslateService) {
    }

    getListType(): Array<SelectItem> {
        return [{
            label: this.i18n('fields.type.text', {nb: 3}),
            value: TypeEnum.String3
        }, {
            label: this.i18n('fields.type.text', {nb: 10}),
            value: TypeEnum.String10
        }, {
            label: this.i18n('fields.type.text', {nb: 25}),
            value: TypeEnum.String25
        }, {
            label: this.i18n('fields.type.text', {nb: 50}),
            value: TypeEnum.String50
        }, {
            label: this.i18n('fields.type.text', {nb: 100}),
            value: TypeEnum.String100
        }, {
            label: this.i18n('fields.type.text', {nb: 255}),
            value: TypeEnum.String255
        }, {
            label: this.i18n('fields.type.textBig'),
            value: TypeEnum.TEXT
        }, {
            label: this.i18n('fields.type.entier', {nb: 2147483647}),
            value: TypeEnum.Int
        }, {
            label: this.i18n('fields.type.decimal', {nb: '2 EXP(63) -1'}),
            value: TypeEnum.BigInt
        }, {
            label: this.i18n('fields.type.decimal', {nb: '999.99'}),
            value: TypeEnum.Decimal52
        }, {
            label: this.i18n('fields.type.decimal', {nb: '999 999.99'}),
            value: TypeEnum.Decimal82
        }, {
            label: this.i18n('fields.type.decimal', {nb: '9 999 999 999.99'}),
            value: TypeEnum.Decimal112
        }, {
            label: this.i18n('fields.type.DateTime'),
            value: TypeEnum.DateTime
        }, {
            label: this.i18n('fields.type.Date'),
            value: TypeEnum.Date
        }, {
            label: this.i18n('fields.type.Time'),
            value: TypeEnum.Time
        }, {
            label: this.i18n('fields.type.uuid'),
            value: TypeEnum.UUID
        }, {
            label: this.i18n('fields.type.boolean'),
            value: TypeEnum.Boolean
        }];
    }

    getListCategories(): Array<SelectItem> {
        const list: Array<SelectItem> = [];
        [
            CategoryFieldEnum.TEXT,
            CategoryFieldEnum.BOOLEAN,
            CategoryFieldEnum.NUMBER,
            CategoryFieldEnum.DATETIME,
            CategoryFieldEnum.DATE,
            CategoryFieldEnum.TIME,
            CategoryFieldEnum.EMAIL,
            CategoryFieldEnum.IATACITY,
            CategoryFieldEnum.IATAAIRPORT,
            CategoryFieldEnum.IATACOUNTRY,
            CategoryFieldEnum.CARRIER,
            CategoryFieldEnum.AFFILIATION,
            CategoryFieldEnum.LANG,
            CategoryFieldEnum.COUNTRY,
            CategoryFieldEnum.CIVILITY,
            CategoryFieldEnum.PHONE,
            CategoryFieldEnum.MOBILE,
            CategoryFieldEnum.PRICE,
            CategoryFieldEnum.BOOKINGREFERENCE,
            CategoryFieldEnum.PRODUCTTYPE,
            CategoryFieldEnum.TECHNICAL
        ].forEach(cat =>
            list.push({
                label: this.i18n('fields.categories.' + cat),
                value: cat
            })
        );
        return list;
    }

    getListCategoriesTypes(): Array<SelectItemGroup> {
        const listType = this.getListType();
        const list: Array<SelectItemGroup> = [];
        [
            {
                cat: CategoryFieldEnum.TEXT,
                types: [TypeEnum.String3, TypeEnum.String10, TypeEnum.String25, TypeEnum.String50, TypeEnum.String100, TypeEnum.String255]
            },
            {
                cat: CategoryFieldEnum.BOOLEAN,
                types: [TypeEnum.Boolean]
            },
            {
                cat: CategoryFieldEnum.NUMBER,
                types: [TypeEnum.Int, TypeEnum.BigInt, TypeEnum.Decimal52, TypeEnum.Decimal82, TypeEnum.Decimal112]
            },
            {
                cat: CategoryFieldEnum.DATETIME,
                types: [TypeEnum.DateTime]
            },
            {
                cat: CategoryFieldEnum.DATE,
                types: [TypeEnum.Date]
            },
            {
                cat: CategoryFieldEnum.TIME,
                types: [TypeEnum.Time]
            },
            {
                cat: CategoryFieldEnum.EMAIL,
                types: [TypeEnum.String255]
            },
            {
                cat: CategoryFieldEnum.IATACITY,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.IATAAIRPORT,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.IATACOUNTRY,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.CARRIER,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.AFFILIATION,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.LANG,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.COUNTRY,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.CIVILITY,
                types: [TypeEnum.String3]
            },
            {
                cat: CategoryFieldEnum.PHONE,
                types: [TypeEnum.String25]
            },
            {
                cat: CategoryFieldEnum.MOBILE,
                types: [TypeEnum.String25]
            },
            {
                cat: CategoryFieldEnum.PRICE,
                types: [TypeEnum.Decimal52, TypeEnum.Decimal82, TypeEnum.Decimal112]
            },
            {
                cat: CategoryFieldEnum.BOOKINGREFERENCE,
                types: [TypeEnum.String25, TypeEnum.String50]
            },
            {
                cat: CategoryFieldEnum.PRODUCTTYPE,
                types: [TypeEnum.String10]
            },
            { 
                cat: CategoryFieldEnum.ACTIVITYSTATUS,
                types:[TypeEnum.String10]
            },
            {
                cat: CategoryFieldEnum.LOYALTYSTATUS,
                types:[TypeEnum.String10]
            },
            {
                cat: CategoryFieldEnum.PURCHASESTATUS,
                types:[TypeEnum.String10]
            },
            {
                cat: CategoryFieldEnum.NEWSLETTER,
                types:[TypeEnum.UUID]
            },
            {
                cat: CategoryFieldEnum.CHANNEL,
                types:[TypeEnum.String10]
            },
            {
                cat: CategoryFieldEnum.TECHNICAL,
                types: []
            }
        ].forEach(cat => {
            const items = listType.filter(t => cat.types.length === 0 ? true : cat.types.includes(t.value));
            list.push({
                label: this.i18n('fields.categories.' + cat.cat),
                value: cat.cat,
                items
            });
        });
        return list;
    }

    private i18n(key: string, interpolateParams?: any) {
        return this.transate.instant(key, interpolateParams);
    }

}
